import { Plus } from 'lucide-react';
import React, { useEffect, useState } from 'react';
import {
    Button,
    Card,
    Col,
    Container,
    Form,
    Image,
    Modal,
    Row,
    Spinner,
    Stack,
    Table,
} from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router';
import { formatDate } from '../../helper';
import { useDoctorAddMutation, useDoctorEditMutation } from './doctorApi';

const AddDoctor = ({ setLoading, edit, setEdit }) => {

    useEffect(() => {
        console.log("edit -- from modal -- ", edit)
    }, [edit])

    const config = {
        email: '',
        password: 'SymInfo2024',
        mobile: '',
        userType: 'DOCTOR',
        languageId: 1,
        name: '',
        lastName: '',
        dateOfBirth: '',
        doYouWearGlasses: true,
        whenIsTheLastTimeYouWentToTheEyeDoctor: '',
        patientNameOfYourUsualEyeDoctor: '',
        patientRppsNumberOfYourUsualEyeDoctor: 0,
        phoneNumber: 0,
        typeOfVision: '',
        patientHappy: '',
        patientSymptoms: '',
        patientDiagnosedWith: '',
        patientHealthConditions: '',
        additionalComments: '',
        doctorRppsNumber: '',
        doctorIdOfRegistration: '',
        doctorAddressOfTheHealthCenter: '',
        city: '',
        gender: '',
        drDesignation: '',
        SubmitTrack: 'Web',
        infoIsExternalDoctor: false,
        infoSSN: '',
        isDoctorAvailable: true,
        amountOfTestperDay: 0,
        doctorPriority: 0,
        imageRetino: true,
        isPiO: true,
    };
    const maxDateValidation = new Date().toISOString().split('T')[0];
    const { t } = useTranslation();
    const [show, setShow] = useState(false);
    const [modalLoading, setModalLoading] = useState(false);
    const [doctorConfig, setDoctorConfig] = useState(config);
    useEffect(() => {
        console.log("doctorConfig ================> ", doctorConfig);
    }, [doctorConfig]);
    const initialInputStatus = {
        name: false,
        lastName: false,
        dateOfBirth: false,
        doctorRppsNumber: false,
        doctorIdOfRegistration: false,
        email: false,
        mobile: false,
        doctorAddressOfTheHealthCenter: false,
        drDesignation: false,
        city: false,
        infoIsExternalDoctor: false,
        isDoctorAvailable: false,
        amountOfTestperDay: false,
        doctorPriority: false,
        imageRetino: false,
        isPiO: false,
    };
    const [inputStatus, setInputStatus] = useState(initialInputStatus);
    const [addDoctor] = useDoctorAddMutation();
    const [editDoctor] = useDoctorEditMutation();
    const navigate = useNavigate();

    const handleChange = (e) => {
        e.preventDefault();
        const { name, value } = e.target;
        setDoctorConfig((prevValues) => {
            return {
                ...prevValues,
                [name]: value,
            };
        });

        setInputStatus((prev) => ({
            ...prev,
            [name]: false,
        }));
    };

    const handleBooleanChange = (e) => {
        const { name, value } = e.target;
        setDoctorConfig((prevValues) => {
            return {
                ...prevValues,
                [name]: value === 'true',
            };
        });

        setInputStatus((prev) => ({
            ...prev,
            [name]: false,
        }));
    };

    const handleNumberChange = (e) => {
        const { name, value } = e.target;
        setDoctorConfig((prevValues) => {
            return {
                ...prevValues,
                [name]: Number(value),
            };
        });

        setInputStatus((prev) => ({
            ...prev,
            [name]: false,
        }));
    };

    useEffect(() => {
        if (Object.keys(edit).length > 0) {
            setShow(true);
            const formattedEditData = {
                ...edit,
                infoIsExternalDoctor: edit.isExternalDoctor,
                dateOfBirth: edit.dateOfBirth
                    ? formatDate(edit.dateOfBirth)
                    : '',
                isDoctorAvailable:
                    edit.isDoctorAvailable !== undefined
                        ? edit.isDoctorAvailable
                        : true,
                amountOfTestperDay:
                    edit.amountOfTestperDay !== undefined
                        ? edit.amountOfTestperDay
                        : 0,
                doctorPriority:
                    edit.doctorPriority !== undefined ? edit.doctorPriority : 0,
                imageRetino:
                    edit.imageRetino !== undefined ? edit.imageRetino : true,
                isPiO: edit.isPiO !== undefined ? edit.isPiO : true,
                isDoctorExpressAvailable: edit.isDoctorExpressAvailable
            };
            setDoctorConfig(formattedEditData);
        }
    }, [edit]);

    useEffect(() => {
        console.log(doctorConfig, 'doctorConfigdoctorConfig');
    }, [doctorConfig]);

    useEffect(() => {
        console.log(inputStatus, 'INPUTSTATUS');
    }, [inputStatus]);

    const handleSubmit = async (event) => {
        event.preventDefault();

        const checkConfig = {
            name: doctorConfig.name,
            lastName: doctorConfig.lastName,
            dateOfBirth: doctorConfig.dateOfBirth,
            doctorRppsNumber: doctorConfig.doctorRppsNumber,
            doctorIdOfRegistration: doctorConfig.doctorIdOfRegistration,
            email: doctorConfig.email,
            mobile: doctorConfig.mobile,
            doctorAddressOfTheHealthCenter:
                doctorConfig.doctorAddressOfTheHealthCenter,
            drDesignation: doctorConfig.drDesignation,
            city: doctorConfig.city,
            infoIsExternalDoctor: doctorConfig.infoIsExternalDoctor,
            isDoctorAvailable: doctorConfig.isDoctorAvailable,
            amountOfTestperDay: doctorConfig.amountOfTestperDay,
            doctorPriority: doctorConfig.doctorPriority,
            imageRetino: doctorConfig.imageRetino,
            isPiO: doctorConfig.isPiO,
        };

        const isAllInputFilled = Object.values(checkConfig).every(
            (value) => value !== null && value !== undefined && value !== ''
        );

        console.log("checkConfig =======", checkConfig)

        console.log("isAllInputFilled === ", isAllInputFilled)
        console.log('CLICKED ON THE SUBMIT BUTTON');

        if (isAllInputFilled) {
            setModalLoading(true);

            console.log('CLICKED ON THE SUBMIT BUTTON - true case');
            try {
                let response;
                if (Object.keys(edit).length > 0) {
                    response = await editDoctor({ ...doctorConfig });
                } else {
                    response = await addDoctor({ ...doctorConfig });
                }

                console.log(response);
                if (response.data) {
                    setEdit({});
                    setShow(false);
                    setDoctorConfig(config);
                    setLoading(true);
                }
            } catch (error) {
                console.log(error, 'error');
            } finally {
                setModalLoading(false);
            }
        } else {
            console.log('CLICKED ON THE SUBMIT BUTTON - false case');
            const updatedStatus = { ...inputStatus };

            if (doctorConfig.name === '') updatedStatus.name = true;
            if (doctorConfig.lastName === '') updatedStatus.lastName = true;
            if (doctorConfig.dateOfBirth === '')
                updatedStatus.dateOfBirth = true;
            if (doctorConfig.doctorRppsNumber === '')
                updatedStatus.doctorRppsNumber = true;
            if (doctorConfig.doctorIdOfRegistration === '')
                updatedStatus.doctorIdOfRegistration = true;
            if (doctorConfig.email === '') updatedStatus.email = true;
            if (doctorConfig.mobile === '') updatedStatus.mobile = true;
            if (doctorConfig.doctorAddressOfTheHealthCenter === '')
                updatedStatus.doctorAddressOfTheHealthCenter = true;
            if (doctorConfig.drDesignation === '')
                updatedStatus.drDesignation = true;
            if (doctorConfig.city === '') updatedStatus.city = true;
            if (doctorConfig.infoIsExternalDoctor === '')
                updatedStatus.infoIsExternalDoctor = true;
            if (doctorConfig.isDoctorAvailable === '')
                updatedStatus.isDoctorAvailable = true;
            if (doctorConfig.doctorPriority === 0 || doctorConfig.doctorPriority === "" || doctorConfig.doctorPriority == null)
                updatedStatus.doctorPriority = true;
            if (doctorConfig.amountOfTestperDay === 0 || doctorConfig.amountOfTestperDay === "" || doctorConfig.amountOfTestperDay == null)
                updatedStatus.amountOfTestperDay = true;
            if (doctorConfig.imageRetino === '')
                updatedStatus.imageRetino = true;
            if (doctorConfig.isPiO === '') updatedStatus.isPiO = true;

            setInputStatus(updatedStatus);
        }
    };

    const handleClose = () => {
        setInputStatus(initialInputStatus);
        setShow(false);
        setEdit({});
        setDoctorConfig(config);
    };

    return (
        <>
            <Button variant="primary" onClick={() => setShow(true)}>
                <Plus width={14} height={14} />
                {t('addOptician')}
            </Button>
            <Modal
                show={show}
                size="lg"
                onHide={handleClose}
                aria-labelledby="contained-modal-title-vcenter"
                backdrop="static"
                keyboard={false}
                centered
            >
                <Form noValidate onSubmit={handleSubmit}>
                    <Modal.Header closeButton>
                        <Modal.Title>
                            {Object.keys(edit).length > 0
                                ? t('editOptician')
                                : t('addOptician')}
                        </Modal.Title>
                    </Modal.Header>
                    <Modal.Body className="modal_form">
                        <Row>
                            <Col md={6}>
                                <Form.Group className="mb-3">
                                    <Form.Label>{t('firstName')}*</Form.Label>
                                    <Form.Control
                                        onChange={handleChange}
                                        value={doctorConfig.name || ''}
                                        type="text"
                                        name="name"
                                        placeholder={t('inputText')}
                                        isInvalid={inputStatus.name}
                                        // isInvalid={false}
                                        required
                                    />
                                    <Form.Control.Feedback type="invalid">
                                        {t('firstName')} {t('isRequired')}
                                    </Form.Control.Feedback>
                                </Form.Group>
                            </Col>
                            <Col md={6}>
                                <Form.Group className="mb-3">
                                    <Form.Label>{t('surName')}*</Form.Label>
                                    <Form.Control
                                        onChange={handleChange}
                                        value={doctorConfig.lastName || ''}
                                        type="text"
                                        name="lastName"
                                        placeholder={t('inputText')}
                                        isInvalid={inputStatus.lastName}
                                        required
                                    />
                                    <Form.Control.Feedback type="invalid">
                                        {t('surName')} {t('isRequired')}
                                    </Form.Control.Feedback>
                                </Form.Group>
                            </Col>
                            <Col md={6}>
                                <Form.Group className="mb-3">
                                    <Form.Label>{t('dateofBirth')}*</Form.Label>
                                    <Form.Control
                                        onChange={handleChange}
                                        max={maxDateValidation}
                                        value={doctorConfig.dateOfBirth || ''}
                                        type="date"
                                        name="dateOfBirth"
                                        placeholder={t('inputText')}
                                        isInvalid={inputStatus.dateOfBirth}
                                        required
                                    />
                                    <Form.Control.Feedback type="invalid">
                                        {t('dateofBirth')} {t('isRequired')}
                                    </Form.Control.Feedback>
                                </Form.Group>
                            </Col>

                            <Col md={6}>
                                <Form.Group className="mb-3">
                                    <Form.Label>{t('RPPS')}*</Form.Label>
                                    <Form.Control
                                        onChange={handleChange}
                                        value={
                                            doctorConfig.doctorRppsNumber || ''
                                        }
                                        type="text"
                                        name="doctorRppsNumber"
                                        placeholder={t('inputText')}
                                        isInvalid={inputStatus.doctorRppsNumber}
                                        required
                                    />
                                    <Form.Control.Feedback type="invalid">
                                        {t('rpp')} {t('isRequired')}
                                    </Form.Control.Feedback>
                                </Form.Group>
                            </Col>
                            <Col md={6}>
                                <Form.Group className="mb-3">
                                    <Form.Label>
                                        {t('ID du médecin')}*
                                    </Form.Label>
                                    <Form.Control
                                        onChange={handleChange}
                                        value={
                                            doctorConfig.doctorIdOfRegistration ||
                                            ''
                                        }
                                        type="text"
                                        name="doctorIdOfRegistration"
                                        placeholder={t('inputText')}
                                        isInvalid={
                                            inputStatus.doctorIdOfRegistration
                                        }
                                        required
                                    />
                                    <Form.Control.Feedback type="invalid">
                                        {t('rpp')} {t('isRequired')}
                                    </Form.Control.Feedback>
                                </Form.Group>
                            </Col>
                            <Col md={6}>
                                <Form.Group className="mb-3">
                                    <Form.Label>{t('email')}*</Form.Label>
                                    <Form.Control
                                        onChange={handleChange}
                                        value={doctorConfig.email || ''}
                                        type="email"
                                        name="email"
                                        placeholder={t('inputText')}
                                        isInvalid={inputStatus.email}
                                        required
                                    />
                                    <Form.Control.Feedback type="invalid">
                                        {t('email')} {t('isRequired')}
                                    </Form.Control.Feedback>
                                </Form.Group>
                            </Col>
                            <Col md={6}>
                                <Form.Group className="mb-3">
                                    <Form.Label>{t('phone')}*</Form.Label>
                                    <Form.Control
                                        onChange={handleChange}
                                        value={doctorConfig.mobile || ''}
                                        type="tel"
                                        name="mobile"
                                        placeholder={t('inputText')}
                                        isInvalid={inputStatus.mobile}
                                        required
                                    />
                                    <Form.Control.Feedback type="invalid">
                                        {t('mobile')} {t('isRequired')}
                                    </Form.Control.Feedback>
                                </Form.Group>
                            </Col>
                            <Col md={6}>
                                <Form.Group className="mb-3">
                                    <Form.Label>
                                        {t(
                                            'Médecin Adresse du Centre de Santé'
                                        )}
                                        *
                                    </Form.Label>
                                    <Form.Control
                                        onChange={handleChange}
                                        value={
                                            doctorConfig.doctorAddressOfTheHealthCenter ||
                                            ''
                                        }
                                        type="text"
                                        name="doctorAddressOfTheHealthCenter"
                                        placeholder={t('inputText')}
                                        isInvalid={
                                            inputStatus.doctorAddressOfTheHealthCenter
                                        }
                                        required
                                    />
                                    <Form.Control.Feedback type="invalid">
                                        {t('address')} {t('isRequired')}
                                    </Form.Control.Feedback>
                                </Form.Group>
                            </Col>
                            <Col md={6}>
                                <Form.Group className="mb-3">
                                    <Form.Label>
                                        {t('Chef de Clinique')}*
                                    </Form.Label>
                                    <Form.Control
                                        onChange={handleChange}
                                        value={doctorConfig.drDesignation || ''}
                                        type="text"
                                        name="drDesignation"
                                        placeholder={t('inputText')}
                                        isInvalid={inputStatus.drDesignation}
                                        required
                                    />
                                    <Form.Control.Feedback type="invalid">
                                        {t('designation')} {t('isRequired')}
                                    </Form.Control.Feedback>
                                </Form.Group>
                            </Col>
                            <Col md={6}>
                                <Form.Group className="mb-3">
                                    <Form.Label>{t('Ville')}*</Form.Label>
                                    <Form.Control
                                        onChange={handleChange}
                                        value={doctorConfig.city || ''}
                                        type="text"
                                        name="city"
                                        placeholder={t('inputText')}
                                        isInvalid={inputStatus.city}
                                        required
                                    />
                                    <Form.Control.Feedback type="invalid">
                                        {t('city')} {t('isRequired')}
                                    </Form.Control.Feedback>
                                </Form.Group>
                            </Col>
                            <Col md={6}>
                                <Form.Group className="mb-3">
                                    <Form.Label>
                                        {t('Type d’opthalologue')}*
                                    </Form.Label>
                                    <Form.Select
                                        aria-label="Default"
                                        name="infoIsExternalDoctor"
                                        onChange={handleBooleanChange}
                                        value={
                                            doctorConfig.infoIsExternalDoctor
                                        }
                                        isInvalid={
                                            inputStatus.infoIsExternalDoctor
                                        }
                                        required
                                    >
                                        <option disabled value={''}>
                                            {t('selectItem')}
                                        </option>
                                        <option value="false">
                                            {t('Téléexpertise')}
                                        </option>
                                        <option value="true">
                                            {t('Sym IA')}
                                        </option>
                                    </Form.Select>
                                    <Form.Control.Feedback type="invalid">
                                        {t("Type d'opticien")} {t('isRequired')}
                                    </Form.Control.Feedback>
                                </Form.Group>
                            </Col>
                            <Col md={6}>
                                <Form.Group className="mb-3">
                                    <Form.Label>
                                        {t('Disponible pour des analyses')}*
                                    </Form.Label>
                                    <Form.Select
                                        aria-label="Default"
                                        name="isDoctorAvailable"
                                        onChange={handleBooleanChange}
                                        value={doctorConfig.isDoctorAvailable?.toString()}
                                        isInvalid={
                                            inputStatus.isDoctorAvailable
                                        }
                                        required
                                    >
                                        <option value="true">{t('Yes')}</option>
                                        <option value="false">{t('No')}</option>
                                    </Form.Select>
                                    <Form.Control.Feedback type="invalid">
                                        {t('Doctor Available')}{' '}
                                        {t('isRequired')}
                                    </Form.Control.Feedback>
                                </Form.Group>
                            </Col>
                            <Col md={6}>
                                <Form.Group className="mb-3">
                                    <Form.Label>
                                        {t('Tests par jour')}
                                    </Form.Label>
                                    <Form.Control
                                        onChange={handleNumberChange}
                                        value={
                                            doctorConfig.amountOfTestperDay || 0
                                        }
                                        type="number"
                                        name="amountOfTestperDay"
                                        placeholder={t('Enter number of tests')}
                                        isInvalid={inputStatus.amountOfTestperDay}
                                        min="0"
                                    />
                                    <Form.Control.Feedback type="invalid">
                                        {t('Tests par jour')} {t('isRequired')}
                                    </Form.Control.Feedback>
                                </Form.Group>
                            </Col>
                            <Col md={6}>
                                <Form.Group className="mb-3">
                                    <Form.Label>
                                        {t('Docteur Priorité')}
                                    </Form.Label>
                                    <Form.Control
                                        onChange={handleNumberChange}
                                        value={doctorConfig.doctorPriority || 0}
                                        type="number"
                                        name="doctorPriority"
                                        isInvalid={inputStatus.doctorPriority}
                                        placeholder={t('Enter priority number')}
                                        min="0"
                                    />
                                    <Form.Control.Feedback type="invalid">
                                        {t('Docteur Priorité')} {t('isRequired')}
                                    </Form.Control.Feedback>
                                </Form.Group>
                            </Col>
                            <Col md={6}>
                                <Form.Group className="mb-3">
                                    <Form.Label>
                                        {t('Images retino obligatoires')}*
                                    </Form.Label>
                                    <Form.Select
                                        aria-label="Default"
                                        name="imageRetino"
                                        onChange={handleBooleanChange}
                                        value={doctorConfig.imageRetino?.toString()}
                                        isInvalid={inputStatus.imageRetino}
                                        required
                                    >
                                        <option value="true">{t('Yes')}</option>
                                        <option value="false">{t('No')}</option>
                                    </Form.Select>
                                    <Form.Control.Feedback type="invalid">
                                        {t('Doctor Available')}{' '}
                                        {t('isRequired')}
                                    </Form.Control.Feedback>
                                </Form.Group>
                            </Col>
                            <Col md={6}>
                                <Form.Group className="mb-3">
                                    <Form.Label>
                                        {t('PIO obligatoire')}*
                                    </Form.Label>
                                    <Form.Select
                                        aria-label="Default"
                                        name="isPiO"
                                        onChange={handleBooleanChange}
                                        value={doctorConfig.isPiO?.toString()}
                                        isInvalid={inputStatus.isPiO}
                                        required
                                    >
                                        <option value="true">{t('Yes')}</option>
                                        <option value="false">{t('No')}</option>
                                    </Form.Select>
                                    <Form.Control.Feedback type="invalid">
                                        {t('Doctor Available')}{' '}
                                        {t('isRequired')}
                                    </Form.Control.Feedback>
                                </Form.Group>
                            </Col>
                            <Col md={6}>
                                <Form.Group className="mb-3">
                                    <Form.Label>{t('expressTest')}</Form.Label>
                                    <Form.Select
                                        name="isDoctorExpressAvailable"
                                        onChange={handleBooleanChange}
                                       value={doctorConfig?.isDoctorExpressAvailable?.toString()} // Ensure it always has a value
                                    >
                                        <option value="false">{t('no')}</option>
                                        <option value="true">{t('yes')}</option>
                                    </Form.Select>
                                </Form.Group>
                            </Col>
                        </Row>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="secondary" onClick={handleClose}>
                            {t('cancel')}
                        </Button>
                        <Button
                            type="submit"
                            variant="primary"
                            disabled={modalLoading}
                        >
                            {modalLoading && (
                                <Spinner
                                    animation="border"
                                    role="status"
                                    size="sm"
                                >
                                    <span className="visually-hidden">
                                        Loading...
                                    </span>
                                </Spinner>
                            )}{' '}
                            {Object.keys(edit).length > 0
                                ? t('update')
                                : t('addNewSheet')}
                        </Button>
                    </Modal.Footer>
                </Form>
            </Modal>
        </>
    );
};

export default AddDoctor;
